import type { WebConsentCategory } from "@/lib/cookie-consent";

export type OptionalCookiePurpose = WebConsentCategory | "both";

const OPTIONAL_COOKIE_NAMES = new Map<string, OptionalCookiePurpose>([
  ["_fbp", "advertising"],
  ["_fbc", "advertising"],
  ["_clck", "analytics"],
  ["_clsk", "analytics"],
  ["CLID", "analytics"],
  ["ANONCHK", "analytics"],
  ["MR", "both"],
  ["MUID", "both"],
  ["SM", "analytics"],
  ["_uetmsclkid", "advertising"],
  ["_uetsid", "advertising"],
  ["_uetsid_exp", "advertising"],
  ["_uetvid", "advertising"],
  ["_uetvid_exp", "advertising"],
  ["MSPTC", "advertising"],
  ["FPAU", "advertising"],
  ["FPGCLAW", "advertising"],
  ["FPGCLGB", "advertising"],
  ["FPGCLGS", "advertising"],
  ["FPGCLDC", "advertising"],
  ["FPGSID", "advertising"],
  ["tsb_compare_src", "advertising"],
]);

const OPTIONAL_COOKIE_PREFIXES: ReadonlyArray<
  readonly [string, OptionalCookiePurpose]
> = [
  // `_gac_*` also begins `_ga`; keep the Advertising-specific prefix first.
  ["_gac_", "advertising"],
  ["_ga", "analytics"],
  ["ph_", "analytics"],
  ["_gcl_", "advertising"],
];

export function optionalCookiePurpose(
  name: string,
): OptionalCookiePurpose | null {
  return (
    OPTIONAL_COOKIE_NAMES.get(name) ??
    OPTIONAL_COOKIE_PREFIXES.find(([prefix]) => name.startsWith(prefix))?.[1] ??
    null
  );
}

export function isOptionalCookieForCategory(
  name: string,
  category: WebConsentCategory,
): boolean {
  const purpose = optionalCookiePurpose(name);
  return purpose === category || purpose === "both";
}

/** Compatibility name: true for every optional Analytics or Advertising ID. */
export function isOptionalAnalyticsCookieName(name: string): boolean {
  return optionalCookiePurpose(name) !== null;
}
